import { APIDecoratorWithBaseURI } from "../../Service/api";

export interface useValidationProps {
    fetcher: (id: string) => Promise<any>
}

export const use2faValidation = (): useValidationProps => {
    const url: string = "two-factor/validate2fa"  

    const fetcher = async (id: string) => {
      return await APIDecoratorWithBaseURI().post(url,
        { code: id }) 
    }

    return {
      fetcher
    }
}


